<h1>Dealer Status Page - @if (!subscribed) {
  <span class="name">Not</span>
} Enrolled</h1>

@if (!loading) {
  @if (subscribed) {
    @if (international) {
      <section>
        <div class="row">          
          <div><h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is enrolled!</h2></div>
          <div class="right"><button [routerLink]="['/account-info']" [queryParams]="{ ref: 'international' }">Account Info</button></div>
        </div>

        <p>You are currently enrolled in the Ford Diagnostics Subscription. This gives all dealership employees access to IDS, FDRS, and Ford DiagNow. 
          For more information or Frequently Asked Questions (FAQs) please navigate to the following – <a href="/faq">Diagnostic Subscription FAQs</a>.</p>
        <ul>
          <li>PA Code: {{sub.siteCode}}</li>
          <li>Number of Subscriptions: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}</li>
        </ul>
        @if (isApa) {
          <p><button [routerLink]="['/request-intl-dealer']">Request more subscriptions</button></p>
        }
      </section>

      @if (pendingRequests.length) {
      <section>
          <p>You have requests for subscriptions waiting for approval:</p>
          <ul>
            @for (pR of pendingRequests; track pR) {
              <li>Requested change to {{pR.license_qty_requested}} subscriptions on {{this.dateFormat(pR.request_date)}}</li>
            }
          </ul>
      </section>
      }
    } @else if (fleet) {
      <section>
        <div class="row">
          <div><h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is enrolled!</h2></div>
          <div class="right"><button [routerLink]="['/account-info']" [queryParams]="{ ref: 'fleet' }">Account Info</button></div>
        </div>
                
        <p>You are currently enrolled in the Ford Diagnostics Subscription. This gives all dealership employees access to IDS, FDRS, and Ford DiagNow. 
          <!-- For more information or Frequently Asked Questions (FAQs) please navigate to the following – <a href="/faq">Diagnostic Subscription FAQs</a>. -->
        </p>
        
        <p style="text-align: right;">
          Yearly Cost Per Subscription: ${{fleetPrice.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}        
        <br> Billing Period: {{ transform(selectedBillingType) }}
          <br>
          @if(transform(selectedBillingType) === "Annual") {
            Current Yearly Billing Amount: ${{(fleetMonthly * 12).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
          } @else if(transform(selectedBillingType) === "Monthly") {
            Current Monthly Billing Amount: ${{(fleetMonthly).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
          }

        </p>

        <p>Your current billing period is: <b>{{ transform(selectedBillingType) }}</b>. If you wish to change the billing period, you can change it on the <a [routerLink]="['/account-info']" [queryParams]="{ ref: 'fleet' }">Account Info</a> page.</p>

        <ul>
          <li>FIN Code: {{sub.siteCode}}</li>
          <li>Number of Subscriptions: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}</li>
          <!-- <li>Number of Subscriptions: {{dealerStatus.tech_count.toLocaleString()}}</li> -->
          <li>Enrolled On: {{dateFormat(sub.startDate)}}</li>          
          <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.</li>
          <!-- <li>Total allowable active sessions in your dealership is {{(sub.maxAllowedUniqueDealerTechnicianLogins * sub.concurrentSessions).toLocaleString()}}.</li> -->
        </ul>
        <p>
          @if(selectedBillingType == "annual" && !admin) {
          <button [routerLink]="['/request-intl-dealer']" [queryParams]="{ ref: 'fleet' }" disabled>Edit the Subscription count</button> &nbsp;
          <button [routerLink]="['/cancel']" [queryParams]="{ ref: 'fleet' }" disabled>Cancel Subscription</button>
          } @else {
          <button [routerLink]="['/request-intl-dealer']" [queryParams]="{ ref: 'fleet' }">Edit the Subscription count</button> &nbsp;
          <button [routerLink]="['/cancel']" [queryParams]="{ ref: 'fleet' }">Cancel Subscription</button>
          }
        </p>
      </section>
    } @else {
      <section>
        <div class="row">
          <div><h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is enrolled!</h2></div>
          <div class="right"><button [routerLink]="['/account-info']" [queryParams]="{ ref: 'dealer' }">Account Info</button></div>
        </div>
        
        <p>You are currently enrolled in the Ford Diagnostics Subscription. This gives all dealership employees access to IDS, FDRS, and Ford DiagNow. 
          For more information or Frequently Asked Questions (FAQs) please navigate to the following – <a href="/faq">Diagnostic Subscription FAQs</a>.</p>
          
        <p style="text-align: right;">Yearly Cost Per Subscription: ${{price.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
        <br>Current Monthly Billing Amount: ${{(monthly).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}</p>

        <ul>
          <li>PA Code: {{sub.siteCode}}</li>
          <!-- <li>Number of Service Technicians: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}</li> -->
          <li>Number of Service Technicians: {{dealerStatus.tech_count.toLocaleString()}}</li>
          <li>Enrolled On: {{dateFormat(sub.startDate)}}</li>          
          <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.</li>
          <!-- <li>Total allowable active sessions in your dealership is {{(sub.maxAllowedUniqueDealerTechnicianLogins * sub.concurrentSessions).toLocaleString()}}.</li> -->
        </ul>
        <p><button [routerLink]="['/cancel']">Cancel Subscription</button></p>
      </section>
    }
  }

  @if (!subscribed) {
    @if (international) {
      @if (isApa) {
        <section>
          <div class="row">
            <div><h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is not enrolled in FDSP.</h2></div>
            <div class="right"><button [routerLink]="['/account-info']" [queryParams]="{ ref: 'international' }">Account Info</button></div>
          </div>

          <p>{{dealer.name}} - {{dealer.pa_code}} is not currently enrolled in Ford Diagnostics Subscription. You will be unable to access IDS, FDRS, or Ford DiagNow until you enroll.</p>
          <p><button [routerLink]="['/request-intl-dealer']">Request subscription</button></p>
        </section>
        @if (pendingRequests.length) {
        <section>
            <p>You have requests for subscriptions waiting for approval:</p>
            <ul>
              @for (pR of pendingRequests; track pR) {
                <li>Requested change to {{pR.license_qty_requested}} subscriptions on {{this.dateFormat(pR.request_date)}}</li>
              }
            </ul>
        </section>
        }
      } @else {
        <section>
          <div class="row">
            <div><h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is not enrolled in FDSP.</h2></div>
            <div class="right"><button [routerLink]="['/account-info']" [queryParams]="{ ref: 'international' }">Account Info</button></div>
          </div>
          
          <p>{{dealer.name}} - {{dealer.pa_code}} is not currently enrolled in Ford Diagnostics Subscription. You will be unable to access IDS, FDRS, or Ford DiagNow until you enroll.</p>
          <p>Contact your region representative to create a subscription.</p>
        </section>
      }
    } @else if (fleet) {
      <section>                
        @if (dueToExpire) {
          <h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is expiring soon.</h2>
          <p>{{dealer.name}} - {{dealer.pa_code}} Ford Diagnostics Subscription subscription is expiring on {{dateFormat(sub.expiresAt)}}. You will be unable to access IDS, FDRS, or Ford DiagNow until you enroll again.</p>
        } @else {
          <h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is not enrolled in FDSP.</h2>
          <p>{{dealer.name}} - {{dealer.pa_code}} is not currently enrolled in Ford Diagnostics Subscription. You will be unable to access IDS, FDRS, or Ford DiagNow until you enroll.</p>
        }          
        <div class="row">
          <div>
            <p>By clicking “Enroll Now” below, you agree to the <a href="/tos">Terms of Sale</a> and will subscribe to the Ford Diagnostics Subscription.</p>
          </div>
          <div class="right"><button [routerLink]="['/account-info']" [queryParams]="{ ref: 'fleet' }">Account Info</button></div>
        </div>
        <p style="text-align: right;">
          Yearly Cost Per Subscription: ${{fleetPrice.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
          <br> Billing Period: {{ transform(selectedBillingType) }}
          <br>
          @if(transform(selectedBillingType) === "Annual") {
            Current Yearly Billing Amount: ${{(fleetMonthly * 12).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
          } @else if(transform(selectedBillingType) === "Monthly") {
            Current Monthly Billing Amount: ${{(fleetMonthly).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
          }
        </p>

        <p>Your current billing period is: <b>{{ transform(selectedBillingType) }}</b>. If you wish to change the billing period, you can change it on the <a [routerLink]="['/account-info']" [queryParams]="{ ref: 'fleet' }">Account Info</a> page.</p>

        <ul>
          <li>FIN Code: {{dealer.pa_code}}</li>
          <li>Number of Subscriptions: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}</li>
          <!-- <li>Number of Subscriptions: {{dealerStatus.tech_count.toLocaleString()}}</li> -->
          @if (sub.expiresAt && !dueToExpire) {
            <li>Expired On: {{dateFormat(sub.expiresAt)}}</li>
          }
          @if (dueToExpire) {
            <li>Expiring On: {{dateFormat(sub.expiresAt)}}</li>
          }          
          <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.</li>
          <!-- <li>Total allowable active sessions in your dealership is {{(sub.maxAllowedUniqueDealerTechnicianLogins * sub.concurrentSessions).toLocaleString()}}.</li> -->
        </ul>
        <p><button [routerLink]="['/enroll']" [queryParams]="{ ref: 'fleet' }">Enroll Now</button></p>
      </section>
    } @else {
      <section>        
        @if (dueToExpire) {
          <h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is expiring soon.</h2>
          <p>{{dealer.name}} - {{dealer.pa_code}} Ford Diagnostics Subscription subscription is expiring on {{dateFormat(sub.expiresAt)}}. You will be unable to access IDS, FDRS, or Ford DiagNow until you enroll again.</p>
        } @else {
          <h2>{{dealer.name}} <code>{{dealer.pa_code}}</code> is not enrolled in FDSP.</h2>
          <p>{{dealer.name}} - {{dealer.pa_code}} is not currently enrolled in Ford Diagnostics Subscription. You will be unable to access IDS, FDRS, or Ford DiagNow until you enroll.</p>
        }          
        <div class="row">        
          <div>
            <p>By clicking “Enroll Now” below, you agree to the <a href="/tos">Terms of Sale</a> and will subscribe to the Ford Diagnostics Subscription.</p>
          </div>
          <div class="right"><button [routerLink]="['/account-info']" [queryParams]="{ ref: 'dealer' }">Account Info</button></div>
        </div>  
        <p style="text-align: right;">Yearly Cost Per Subscription: ${{price.toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}
         <br> Current Monthly Billing Amount: ${{(monthly).toLocaleString(undefined, {maximumFractionDigits: 2, minimumFractionDigits: 2})}}</p>
        <ul>
          <li>PA Code: {{dealer.pa_code}}</li>
          <!-- <li>Number of Service Technicians: {{sub.maxAllowedUniqueDealerTechnicianLogins.toLocaleString()}}</li> -->
          <li>Number of Service Technicians: {{dealerStatus.tech_count.toLocaleString()}}</li>
          @if (sub.expiresAt && !dueToExpire) {
            <li>Expired On: {{dateFormat(sub.expiresAt)}}</li>
          }
          @if (dueToExpire) {
            <li>Expiring On: {{dateFormat(sub.expiresAt)}}</li>
          }          
          <li>Each Technician may be logged into {{sub.concurrentSessions.toLocaleString()}} instances of software at one time.</li>
          <!-- <li>Total allowable active sessions in your dealership is {{(sub.maxAllowedUniqueDealerTechnicianLogins * sub.concurrentSessions).toLocaleString()}}.</li> -->
        </ul>
        <p><button [routerLink]="['/enroll']">Enroll Now</button></p>
      </section>
    }
  }
}

@if (loading) {
  <section>
    <p><img src="./assets/loader.gif"> Retrieving enrollment status</p>
    <p><button (click)="retry()">Retry</button></p>
  </section>
}
